/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterUserRatingKind = (typeof FilterUserRatingKind)[keyof typeof FilterUserRatingKind];

export const FilterUserRatingKind = {
  user_rating: 'user_rating',
} as const;
